import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NICmsBlock } from '@icms/core/resource/block/icms-block';

export namespace NRewardBasketValidationModal {
    export const BLOCK_ID = 'reward-basket-validation-modal';

    export interface IBlockData extends NICmsBlock.IData<IBlockDataContent> {}

    export interface IBlockDataContent {
        title: string;
        subtitle?: string;
        description?: string;
        buttonText?: string;
    }
}

@DfCmsModal({
    id: NRewardBasketValidationModal.BLOCK_ID,
    name: 'Reward Basket Validation',
    position: 'custom',
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' || sizeId === 'M' ? '90vw' : '500px',
        width: sizeId === 'S' || sizeId === 'M' ? '90vw' : '500px',
        modalClass: 'reward-basket-validation-modal p-a-0'
    }),
    blockGroup: 'modals',
    priority: 20,
    autoCreate: true,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X'])
})
@ICmsComponent<RewardBasketValidationModalComponent>({
    id: NRewardBasketValidationModal.BLOCK_ID,
    block: {
        url: NRewardBasketValidationModal.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Reward Basket Validation Popup',
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            description: 'Please add products to your basket to redeem this reward'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle'
        }
    ]
})
@Component({
    selector: 'reward-basket-validation-modal',
    templateUrl: './reward-basket-validation-modal.component.html',
    styleUrls: ['./reward-basket-validation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, ICmsClientModule]
})
export class RewardBasketValidationModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content!: NRewardBasketValidationModal.IBlockDataContent;

    constructor(private modalRef: ModalRef<any>) {
        super();
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    protected close() {
        this.modalRef.close();
    }
}
